import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {CallToAction} from '../models';

@Injectable()
export class CallToActionService extends IoService {
  protected model = CallToAction;
  protected listUrl = '/ctas/';
}
